import { gql } from "@apollo/client";export default gql`mutation deleteDocument($id: Int!) {
    deleteDocument: delete_home_explore_document_by_pk(id: $id) {
        id
    }
}
`;
